// extracted by mini-css-extract-plugin
export var bin = "RemoveFromCartButton-module--bin---R4JH";
export var container = "RemoveFromCartButton-module--container--TBAJo";